import CitySEOHead from "@/components/feature/CitySEOHead";
import NevadaHeroSection from "./components/HeroSection";
import NevadaCitiesDirectory from "./components/CitiesDirectory";
import NevadaStateResources from "./components/StateResources";
import NevadaFAQSection, { faqs } from "./components/FAQSection";
import NevadaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const services = [
  { name: "Emergency Passport", description: "Urgent passport processing for Nevada travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Nevada with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
];

const mappedFaqs = faqs.map((f) => ({ q: f.question, a: f.answer }));

export default function NevadaPage() {
  return (
    <>
      <CitySEOHead
        city="Nevada"
        state="Nevada"
        stateAbbr="NV"
        route="/states/nevada"
        title="Nevada Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Nevada — Las Vegas, Henderson, Reno, Sparks. Nevada has no local passport agency. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Nevada, United States"
        geoPosition="38.8026;-116.4194"
        faqs={mappedFaqs}
        servicesSchema={services}
      />
      <div className="font-sans">
        <NevadaHeroSection />
        <NevadaCitiesDirectory />
        <NevadaStateResources />
        <NevadaFAQSection />
        <SEOCrossLinks state="NV" />
        <NevadaFinalCTA />
      </div>
    </>
  );
}